module.exports = __webpack_public_path__ + "img/daxiao.745356ea.png";